import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type { MachineContext } from '../ResolutionFlow.machine.types'

export async function getIssueData({
  diagnosisV2CustomerIssues,
  orderlineId,
}: MachineContext) {
  try {
    if (!orderlineId) {
      return Promise.reject(Error('orderlineId is required'))
    }
    const $httpFetch = useHttpFetch()
    const payload = await $httpFetch(
      '/help-center/api/v1/auth/diagnosis/problem',
      {
        query: {
          orderlineId,
          customerIssues: diagnosisV2CustomerIssues.join(';'),
        },
      },
    )

    return {
      customerIssuesAction: payload.action,
    }
  } catch (error) {
    return Promise.reject(error)
  }
}
